import ContactUs from "../../components/contact/contactUs";

const RefundPolicy = () => {

    return (
        <div className="flex flex-col gap-12">


            <section className="home-container !bg-fraud-banner !h-[600px]  !bg-cover ">
                <div className="justify-center items-center flex flex-col gap-6 xs:!h-auto md:!h-auto xs:gap-16  xs:!pt-[120px] sm:!pt-[120px] md:!pt-[220px]  sm:!pb-[120px] xs:px-4 px-16 text-center sm:text-left">
                    <h1 className="text-6xl text-white font-semibold">Refund Policy</h1>
                    {/* <p className="text-white text-base">Fraud Prevention Alert: Protect Your Assets with Vizion LLC
                    </p> */}
                </div>

            </section>

            <div className=" px-16 pb-8 xs:px-4 space-y-4 ">
                <h5 className="text-black text-xl space-y-3" >
                    <p className="font-bold">  Introduction: </p>

                    <p> At Labelle Digital LLC, we specialize in the liquidation of gift cards. Our goal is to ensure
                        that every transaction is conducted transparently and fairly. This refund policy outlines
                        the circumstances under which a refund may be issued. </p>

                </h5>

                <h5 className="text-black text-xl space-y-3 font-bold" >
                    Refund Eligibility:

                </h5>


                <h5 className="text-black text-xl font-bold">
                1. Fraudulent Transactions:
                </h5>
                    
                    <ul className=" text-xl pl-6">
                        <li className="li ">
                            Refunds will only be issued in cases where there is clear and verifiable
                            evidence of fraud. Customers must report any fraudulent transactions
                            within 90 days of the transaction date.
                        </li>
                        <li className="li">Evidence of fraud may include, but is not limited to, discrepancies in the
                            gift card balance as confirmed by the issuing retailer, or unauthorized use
                            of payment methods.</li>

                        <li>
                            All claims of fraud will be thoroughly investigated in cooperation with
                            relevant authorities and the issuing retailer. The outcome of the
                            investigation will determine the eligibility for a refund.
                        </li>
                    </ul>



                <h5 className="text-black text-xl font-bold">
                    Procedure for Requesting a Refund:
                </h5>

                <h5 className="text-black text-xl font-bold">
                1. Notification:
                </h5>

                   

                    <ul className=" pl-6 text-xl">
                        <li className="li ">
                            To initiate a refund claim, customers must contact our customer service
                            department at support@lbdigital.info within the specified timeframe

                        </li>
                        <li className="li">The customer should provide all relevant information and evidence related
                            to the suspected fraudulent transaction. This may include transaction
                            receipts, proof of payment, communication records, and any
                            correspondence with the card issuer regarding the gift card’s balance.</li>
                    </ul>



                <h5 className="text-black text-xl font-bold">
                    2. Investigation:
                </h5>



                <ul className=" pl-6 text-xl">
                    <li className="li ">
                        Upon receipt of a refund request, we will conduct an investigation to verify
                        the claim. The duration of the investigation may vary but will typically be
                        completed within 5 business days.

                    </li>
                    <li className="li">We reserve the right to request additional documentation or evidence to
                        support the claim.
                    </li>

                </ul>

                <h5 className="text-black text-xl font-bold">
                    3. Refund Issuance:
                </h5>

                <ul className=" pl-6 text-xl">
                    <li className="li ">
                        If a refund claim is validated, we will issue a refund to the original method
                        of payment within 1 business day following the conclusion of our
                        investigation.

                    </li>
                    <li className="li">Refunds will be issued in the amount equal to the purchase price of the
                        gift card.
                    </li>

                </ul>

                <h5 className="text-black text-xl font-bold">General Terms:

                </h5>

                <ul className=" pl-6 text-xl">
                    <li className="li ">
                        Refunds are limited to the original purchase price of the gift card.

                    </li>
                    <li className="li">We reserve the right to deny any refund request that does not meet our policy
                        requirements.
                    </li>

                    <li className="li">This refund policy is subject to change at any time without notice.
                    </li>

                </ul>



                <h5 className="text-black text-xl font-bold">
                    Contact Us

                </h5>

                <h5 className="text-black text-xl">
                    For more information or to submit a refund request, please contact our customer
                    service team at support@lbdigital.info

                </h5>




            </div>
            <ContactUs />
        </div>


    )
}
export default RefundPolicy;